import { requestInit } from 'universal-scripts';

const initialState = 1200;

const dimensionReducer = (state = initialState, action) => {
	if (action.type === requestInit) {
		if (action.payload.cookies?.width) {
			return Number.parseInt(action.payload.cookies.width);
		}
	}
	if (action.type === 'width/change') {
		return action.payload;
	}
	return state;
};

export default dimensionReducer;
